import {useMemo} from "react";
import {useAtomValue} from "jotai";
import {activeCompanyFieldsLoadable} from "../store/activeCompanyFieldsStore";
import {selectedEntityAtom} from "../store/filterSelectionStore";
import {createFeatureCollection} from "../utils/mapUtils";

export const useFieldsGeojson = () => {
    const fieldsState = useAtomValue(activeCompanyFieldsLoadable);
    const selectedEntity = useAtomValue(selectedEntityAtom);

    const fields = useMemo(() => {
        if (fieldsState.state === "hasData" && selectedEntity) {
            if (selectedEntity.entityType === "company") {
                return fieldsState.data.fields;
            } else if (selectedEntity.entityType === "farm") {
                return fieldsState.data.mapByFarmId[selectedEntity.entityId];
            } else {
                const field = fieldsState.data.mapByFieldId[selectedEntity.entityId];
                if (field === undefined) {
                    return null;
                } else {
                    return field.farmId ? fieldsState.data.mapByFarmId[field.farmId] : [field];
                }
            }
        } else {
            return null;
        }
    }, [fieldsState, selectedEntity]);

    return useMemo(() => {
        if (fields) {
            return createFeatureCollection(fields);
        } else {
            return null;
        }
    }, [fields]);
};
